/**
 * isMountedRef.js
 * Created by calhosh on 9/15/2021.
 */
import {useRef, useEffect} from 'react';

export default function useIsMountedRef() {
	const isMountedRef = useRef(null);
	useEffect(() => {
		isMountedRef.current = true;
		return () => (isMountedRef.current = false);
	});
	return isMountedRef;
}
